import SliceNames from '@/state/enum';
import { WindowState } from '@/state/slices/window/typings';

const windowState: WindowState = {
	[SliceNames.WINDOW]: {
		width: globalThis.innerWidth,
		height: globalThis.innerHeight,
	},
};

export default windowState;
